export const WhatsAppPreview = (message) => {
    // Function to convert WhatsApp formatting to HTML
    function parseWhatsAppFormatting(text) {
      // First, escape HTML special characters to avoid injection issues.
      function escapeHTML(s) {
        return s.replace(/&/g, "&")
                .replace(/</g, "<")
                .replace(/>/g, ">");
      }
      text = escapeHTML(text);

      // Process triple backticks for a monospace block (<pre>).
      text = text.replace(/```([\s\S]+?)```/g, function(match, p1) {
        return "<pre>" + p1 + "</pre>";
      });

      // Process inline code using single backticks.
      text = text.replace(/`([^`\n]+?)`/g, function(match, p1) {
        return "<code>" + p1 + "</code>";
      });

      // Process bold formatting: *text*
      text = text.replace(/\*(.+?)\*/g, function(match, p1) {
        return "<strong>" + p1 + "</strong>";
      });

      // Process italic formatting: _text_
      text = text.replace(/_(.+?)_/g, function(match, p1) {
        return "<i>" + p1 + "</i>";
      });

      // Process strikethrough formatting: ~text~
      text = text.replace(/~(.+?)~/g, function(match, p1) {
        return "<del>" + p1 + "</del>";
      });

      // Process blockquotes: lines starting with "> "
      text = text.split('\n').map(function(line) {
        // Note: ">" was escaped to ">" when escaping HTML
        if (line.indexOf("> ") === 0) {
          return "<blockquote>" + line.substring(5) + "</blockquote>";
        }
        return line;
      }).join("\n");

      // Process lists.
      // Split into lines and group consecutive list items.
      let lines = text.split('\n');
      let resultLines = [];
      let inUnorderedList = false;
      let inOrderedList = false;
      for (let i = 0; i < lines.length; i++) {
        let line = lines[i];
        // Unordered list: lines starting with "* " or "- "
        if (/^(?:\* |- )/.test(line)) {
          if (!inUnorderedList) {
            inUnorderedList = true;
            resultLines.push("<ul>");
          }
          line = line.replace(/^(?:\* |- )/, "");
          resultLines.push("<li>" + line + "</li>");
        }
        // Ordered list: lines starting with "number. "
        else if (/^\d+\.\s/.test(line)) {
          if (!inOrderedList) {
            inOrderedList = true;
            resultLines.push("<ol>");
          }
          line = line.replace(/^\d+\.\s/, "");
          resultLines.push("<li>" + line + "</li>");
        }
        else {
          if (inUnorderedList) {
            resultLines.push("</ul>");
            inUnorderedList = false;
          }
          if (inOrderedList) {
            resultLines.push("</ol>");
            inOrderedList = false;
          }
          resultLines.push(line);
        }
      }
      if (inUnorderedList) { resultLines.push("</ul>"); }
      if (inOrderedList) { resultLines.push("</ol>"); }
      text = resultLines.join("\n");

      // Handle line breaks and trim any leading/trailing whitespace
      text = text.split('\n')
        .map(line => line.trim()) // Remove leading/trailing spaces from each line
        .join('<br>');

      return text.trim(); // Remove any leading/trailing whitespace from final result
    }

    return `<div class="message-container">
    <div class="message-body">
      <div class="message-main-sender">
        <div class="sender">
          <div class="message-text">
            ${parseWhatsAppFormatting(message)}
          </div>
          <span class="message-time">${new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}</span>
        </div>
      </div>
    </div>
  </div>`;
};
